const REVERS_TRANSLATE_API_PATH = 'api';

const withTrailingSlash = (baseUrl: string): string =>
  baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;

const baseUrlFromEnvironment = import.meta.env.VITE_REVERS_TRANSLATE_URL;

export const REVERS_TRANSLATE_RESOURCE = baseUrlFromEnvironment
  ? `${withTrailingSlash(baseUrlFromEnvironment)}${REVERS_TRANSLATE_API_PATH}`
  : undefined;
export const REVERS_TRANSLATE_SCOPE = 'suggestions:write';
export const DEFAULT_TERM_SUGGESTION_APP_NAME = 'reversio-front';
export const TERM_SUGGESTION_BATCH_SIZE = 500;
export const TERM_SUGGESTION_TTL_IN_MILLISECONDS = 7 * 24 * 60 * 60 * 1000;
export const DEFAULT_SYNC_INTERVAL_IN_SECONDS = 1800;

const MILLISECONDS_IN_A_SECOND = 1000;

interface ReversTranslateConfiguration {
  baseUrl: string;
  projectId: string;
  syncIntervalInMilliseconds: number;
}

export const getReversTranslateConfiguration = ():
  | ReversTranslateConfiguration
  | undefined => {
  const baseUrl = import.meta.env.VITE_REVERS_TRANSLATE_URL;
  const projectId = import.meta.env.VITE_REVERS_TRANSLATE_PROJECT_ID;
  const syncInterval = import.meta.env
    .VITE_REVERS_TRANSLATE_SYNC_INTERVAL_IN_SECONDS;

  if (!baseUrl || !projectId) {
    return undefined;
  }

  const parsedSyncInterval = Number(syncInterval);
  const syncIntervalInSeconds =
    Number.isFinite(parsedSyncInterval) && parsedSyncInterval > 0
      ? parsedSyncInterval
      : DEFAULT_SYNC_INTERVAL_IN_SECONDS;

  return {
    baseUrl: withTrailingSlash(baseUrl),
    projectId,
    syncIntervalInMilliseconds:
      syncIntervalInSeconds * MILLISECONDS_IN_A_SECOND,
  };
};

export const isDynamicTermSuggestionEnabled = (): boolean => {
  return !!getReversTranslateConfiguration();
};
